import { Icon } from '@aqarmap/aqarmap-ui';

export default function Address({
  address,
  className = '',
}: {
  address: string;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center gap-x-2 max-w-full min-w-0 ${className}`}
    >
      <Icon name="location" size="20px" />
      <p
        className="flex-1 min-w-0 w-full truncate text-caption text-gray__dark_2"
        title={address}
      >
        {address}
      </p>
    </div>
  );
}
